<!-- 表二列表 -->

<template>
	<div class="ListCage Rtable6">

		<div class="tabTtl">
			 <span v-if="pressType == 1">表 1-6：重点音像制品情况登记表</span>
			 <span v-else>表 1-6：重点电子出版物情况登记表</span>
		 	 <div class="tabBtns">
		 	 	     <el-button size="mini" @click="goBack">返回</el-button>
					 <!-- <el-select v-model="value" clearable placeholder="历史版本列表" class="selectTime" @change="gethistory(value)">
						 <el-option
								 v-for="item in options"
								 :key="item.id"
								 :label="item.value"
								 :value="item.id">
						 </el-option>
					 </el-select> -->
		 	 </div>
		 </div>
	     <div class="ctrlsLine">
              <el-input v-model="seekPms.keyword" size="small"></el-input>
              <el-button class="seekBtn" @click="tabSeek('init')" size="small">查询</el-button>
         </div>
         <div class="tabArea">
         	  <el-table :data="tabDat" border style="width: 100%" v-loading="loading">
	              <el-table-column label="序号" width="60" align="center">
					 <template slot-scope="scope">
						{{ scope.$index + 1 + 15*(seekPms.no - 1) }}
					 </template>
	              </el-table-column>
	              <el-table-column prop="proName" label="项目名称" align="center">
	              </el-table-column>
	              <el-table-column label="重点项目名称" align="center">
                    <template slot-scope="scope">
                        {{ scope.row | translate('C021',dicMap) }}
                    </template>
	              </el-table-column>
	              <el-table-column label="级别" align="center">
                    <template slot-scope="scope">
                        {{ scope.row | translate('C024',dicMap) }}
                    </template>
	              </el-table-column>
	              <el-table-column prop="ydDate" label="拟完成时间" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.ydDate | stringTrans('time') }}
                    </template>
	              </el-table-column>
	              <el-table-column prop="remark" label="备注" align="center">
	              </el-table-column>
	              <el-table-column label="操作" width="150" align="center">
	                 <template slot-scope="scope">
                         <el-button size="mini" @click="memberEdit(scope.row)" type="primary">查看</el-button>
                     </template>
	              </el-table-column>
              </el-table>
			 <div v-show="value!==''">
				 <p>历史版本：</p>
				 <el-table :data="historyJsonParams" border style="width: 100%" v-loading="loading">
					 <el-table-column label="序号" width="60" align="center">
						 <template slot-scope="scope">
							 {{ scope.$index + 1 + 15*(seekPms.no - 1) }}
						 </template>
					 </el-table-column>
					 <el-table-column prop="proName" label="项目名称" align="center">
					 </el-table-column>
					 <el-table-column label="重点项目名称" align="center">
						 <template slot-scope="scope">
							 {{ scope.row | translate('C021',dicMap) }}
						 </template>
					 </el-table-column>
					 <el-table-column label="级别" align="center">
						 <template slot-scope="scope">
							 {{ scope.row | translate('C024',dicMap) }}
						 </template>
					 </el-table-column>
					 <el-table-column prop="ydDate" label="拟完成时间" align="center">
						 <template slot-scope="scope">
							 {{ scope.row.ydDate | stringTrans('time') }}
						 </template>
					 </el-table-column>
					 <el-table-column prop="remark" label="备注" align="center">
					 </el-table-column>
					 <el-table-column label="操作" width="150" align="center">
						 <template slot-scope="scope">
							 <el-button size="mini" @click="memberEdit(scope.row)" type="primary">查看</el-button>
						 </template>
					 </el-table-column>
				 </el-table>
			 </div>
			  <div class="headBar">
				 <span>申报人信息</span>
			  </div>
			 <div class="editArea newEditArea" :class="value!==''?'newStyle':''">
				 <div class="editBox">
					 <p class="edName">申报人：</p>
					 <div class="edInp">
						 <el-input disabled size="small" v-model="declare.personnel"></el-input>
					 </div>
				 </div>
				 <div class="editBox">
					 <p class="edName">联系方式：</p>
					 <div class="edInp">
						 <el-input disabled size="small" v-model="declare.contact"></el-input>
					 </div>
				 </div>
				 <div class="editBox">
					 <p class="edName">申报时间：</p>
					 <div class="edInp">
						 <el-input disabled size="small" v-model="updatedAt"></el-input>
					 </div>
				 </div>
			 </div>
			 <div class="editArea newEditArea" :class="value!==''?'newStyle':''" v-show="value!==''">
				 <div class="editBox">
					 <p class="edName">申报人：</p>
					 <div class="edInp">
						 <el-input disabled size="small" v-model="historyDeclare.personnel"
								   :class="historyDeclare.personnel!==declare.personnel?'highlight':''">
						 </el-input>
					 </div>
				 </div>
				 <div class="editBox">
					 <p class="edName">联系方式：</p>
					 <div class="edInp">
						 <el-input disabled size="small" v-model="historyDeclare.contact"
								   :class="historyDeclare.contact!==declare.contact?'highlight':''">
						 </el-input>
					 </div>
				 </div>
				 <div class="editBox">
					 <p class="edName">申报时间：</p>
					 <div class="edInp">
						 <el-input disabled size="small" v-model="historyDeclare.updatedAt"
								   :class="historyDeclare.updatedAt!==updatedAt?'highlight':''">
						 </el-input>
					 </div>
				 </div>
			 </div>
         </div>
		 <div class="pageCage" v-if="pgAll > 1">
			 <el-pagination
				 @current-change="pageSent"
				 :current-page='seekPms.no'
				 layout="prev, pager, next"
				 :page-count="pgAll">
			 </el-pagination>
		 </div>
	</div>
</template>

<script>
    import { tabList6,tab6Remove,tab6Clean,pSubmitHistoryList } from '@/api/pressRole/pressRole';
	import { getFileToken } from '@/api/account';
    export default{
         data(){
             return{
				 pressType:this.$route.query.pressType,
                 loading:false,
                 tabDat:[],
                 detArrs:[],
                 dicMap:{},
                 yearSet:0,
                 seekPms:{
                    keyword:'',
                    no:1,
                    size:15
                 },
				 declare:{
					 personnel:"",
					 contact:""
				 },
				 updatedAt:'',
				 historyJsonParams:[],
				 historyJson:[],
				 historyDeclare:{
					 personnel:"",
					 contact:"",
					 updatedAt:''
				 },
				 options:[],
				 value:'',
             }
         },
         filters:{
              translate:function(dat,code,transMap){
					if(code == 'C021'){
						 if(transMap[code][dat.importantProName] == '其他'){
								 return dat.importantProNameOther;
						 }else{
							   return transMap[code][dat.importantProName]
						 }
					}else if(code == 'C024'){
						if(transMap[code][dat.hjLevel] == '其他'){
								 return dat.hjLevelOther;
						}else{
							   return transMap[code][dat.hjLevel]
						}
					}else{
						return transMap[code][dat];
					}

              },

              stringTrans:function(dat,code){
                  if(code == 'time'){
                     return dat.substr(0,10);
                  }
              }
         },
         methods:{

             tabSeek:function(type){
                 this.loading = true;
                 if(type == 'init'){
                    this.seekPms.no = 1;
                 }

                 tabList6(this.seekPms).then(response => {
                    let vm = this;
                    setTimeout(function(){
                        vm.tabDat = response.pImportantProductsList;
                        vm.loading = false;
						vm.pgAll = response.totalPages;
						if(response.pOrganizationPersonnel!==null){
							vm.declare.contact = response.pOrganizationPersonnel.contact;
							vm.declare.personnel = response.pOrganizationPersonnel.personnel;
							vm.updatedAt = response.pOrganizationPersonnel.updatedAt;
						}
                    },300)
                 })
             },

             selectionChange:function(selection){
                 let newArr = [];
                 for(let i = 0;i < selection.length;i++){
                     newArr.push(selection[i].id);
                 }
                 this.detArrs = newArr;
             },
             dictInit:function(){
                let nameArr = ['C021','C024'];
                let newPromise = this.$store.dispatch('dictUpdate',{codeArr:nameArr,type:'map'});
                newPromise.then(result => {
                     this.dicMap = result;
                     this.tabSeek();
                })

             },
             memberEdit:function(dat){
                 let pathParams = {
                    pressId:this.$route.query.pressId,
                    mtId:this.$route.query.mtId,
                    pressType:this.$route.query.pressType,
                 }

                 if(dat){
                    pathParams.id = dat.id;
                 }

                 this.$router.push({
                    path:'edsct_tab6',
                    query:pathParams
                 })
             },

			 pageSent:function(inx){
					this.seekPms.no = inx;
					this.tabSeek();
			 },

             goBack:function(){
                 this.$router.go(-1);
             },
			 // 获取出版单位历史提交版本列表
			 getHistoryList:function(){
				 let that = this;
				 pSubmitHistoryList({publishMaterialId:this.$route.query.mtId}).then(response => {
					 that.historyJson = response.pSubmitHistoryList;
					 for (const list of response.pSubmitHistoryList) {
						 that.options.push({'value':list.createdAt,'id':list.id})
					 }
				 })
			 },
			 // 获取出版单位历史提交json数据
			 gethistory:function(id){
				 const that = this;
				 for (const list of that.historyJson) {
					 if(id == list.id){
						 that.historyJsonParams = JSON.parse(list.afterJson);
						 console.log(that.historyJsonParams)
						 that.historyDeclare =JSON.parse(list.submittor);
					 }
				 }
				 // 获取图片
				 getFileToken().then(data => {
					 that.historyImgUrl = process.env.BASE_API + '/File/File/download/token/' + data.resultStatus.token + '/id/' + that.historyJsonParams.yyzzId;
				 })
			 },
         },
		mounted(){
			this.getHistoryList();
		},
         created:function(){
             this.seekPms.publishMaterialId = this.$route.query.mtId;
             this.dictInit();
         }
    }

</script>

<style lang="scss">

    @import "src/styles/pressRoleL";

		.Rtable6 .pageCage{
			  padding: 30px 0px;
				text-align: center;
		}
	.Rtable6{
		.highlight{
			.el-input__inner,.el-textarea__inner{
				color: red!important;
			}
		}
		.newStyle{
			margin: 30px 0!important;
			width: 50%!important;
			overflow: hidden;
			float: left;
		}
		.selectTime{
			float: left;
			font-weight: normal;
			margin: -5px 30px;
		}
		.editBox{
			overflow: hidden;
		}
		.headBar {
			padding: 0px 24px;
			height: 45px;
			line-height: 45px;
			background: #F8F8F8;
			color: #666666;
			margin-top: 12px;
		}
		.newEditArea {
			width: 80%;
			margin: 0 auto;
			padding: 30px;

			.editBox {
				width: 100%;
				height: auto;
				overflow: hidden;

				p {
					float: left;
					width: 100px;
					text-align: right;
				}

				.edInp {
					width: 300px;
					float: left;
					margin: 10px;
				}
			}
		}
	}

</style>



// WEBPACK FOOTER //
// table6.vue?db030762